module.exports = __webpack_public_path__ + "static/media/mare4_1716502910401.1b5cb0b3.jpg";